import { Professional, ProfessionalFormationTypeEnum } from '@medprev-web-app/api-graphql-client';

import {
  ProfessionalFormationTypeTranslationMap,
} from '@/types/professional/professional.type';

export function formatProfessionalFormations(professional: Professional): string[] {
  return (professional.professionalFormations ?? [])
    .map((formation) => {
      const { description, location, completionYear, type } = formation;

      const translatedType
        = type != null
          ? ProfessionalFormationTypeTranslationMap[type]
          : '';

      const parsedYear = completionYear ? Number(completionYear) : null;

      let formattedString
        = type === ProfessionalFormationTypeEnum.Other ? description : `${translatedType} em ${description}`;

      if (location) {
        formattedString += ` - ${location}`;
      }

      if (parsedYear !== null) {
        formattedString += ` (${parsedYear})`;
      }

      return {
        formattedString,
        completionYear: parsedYear,
        type,
      };
    })
    .sort((a, b) => {
      if (a.type !== ProfessionalFormationTypeEnum.Other && b.type !== ProfessionalFormationTypeEnum.Other) {
        if (a.completionYear !== null && b.completionYear !== null) {
          return b.completionYear - a.completionYear;
        }
        if (a.completionYear === null && b.completionYear !== null) {
          return 1;
        }
        if (b.completionYear === null && a.completionYear !== null) {
          return -1;
        }
        return 0;
      }

      if (a.type === ProfessionalFormationTypeEnum.Other && b.type !== ProfessionalFormationTypeEnum.Other) {
        return 1;
      }
      if (b.type === ProfessionalFormationTypeEnum.Other && a.type !== ProfessionalFormationTypeEnum.Other) {
        return -1;
      }

      if (a.completionYear !== null && b.completionYear !== null) {
        return b.completionYear - a.completionYear;
      }

      return 0;
    })
    .map((formation) => formation.formattedString)
    .filter((str): str is string => typeof str === 'string' && str !== undefined);
}

export function formatProfessionalLanguages(professional: Professional): string[] {
  return (professional.languageAndAccessibility ?? []).map((language) => language);
}

export function formatProfessionalTreatments(professional: Professional): string[] {
  return (professional.treatments ?? []).map((treatment) => treatment);
}

export function formatProfessionalLicenses(professional: Professional): string[] {
  return (professional.licenses ?? []).map((license) => {
    return `${license.certificationBodyInitials}/${license.licenseState} - ${license.licenseRecord}`;
  });
}
